/* eslint-disable no-underscore-dangle */
/* eslint-disable import/prefer-default-export */
import { SearchableRecordInstantSearch } from '@livv/models';
import { Hit, HitAttributeHighlightResult, HitHighlightResult } from 'instantsearch.js';

const isAttributeHighlighted = (
    hitAttribute:
        | HitAttributeHighlightResult
        | HitAttributeHighlightResult[]
        | HitHighlightResult
        | HitHighlightResult[],
): boolean => {
    if (Array.isArray(hitAttribute)) {
        return hitAttribute.some((value) => {
            // asserting that we need to go deeper into the object to find the matchLevel key
            if (!Object.keys(value).includes('matchLevel')) {
                return Object.values(value).some((nestedValue) =>
                    isAttributeHighlighted(nestedValue),
                );
            }

            return value.matchLevel !== 'none';
        });
    }

    return hitAttribute.matchLevel !== 'none';
};

export const getHighlightedAttributes = (hit: Hit<SearchableRecordInstantSearch>): string[] => {
    if (!hit?._highlightResult) {
        return [];
    }

    return Object.keys(hit._highlightResult).filter((key) => {
        if (!hit._highlightResult) {
            return false;
        }

        return isAttributeHighlighted(hit._highlightResult[key]);
    });
};
